import { DateTime } from 'luxon'

const displayTimeOffset = (date, timezone = 'UTC') => {
  if (!date) {
    return '';
  }

  try {
    const dateTime = DateTime.fromISO(date, { zone: timezone });
    return dateTime.toFormat('h:mm a');
  } catch (error) {
    console.error('Error parsing date or timezone:', error);
    return '';
  }
}

export default displayTimeOffset


//ADDING THE BELOW FOR A HOTFIX TO PROD, WE SHOULD REFACTOR AND CREATE A MIGRATION SCRIPT FOR EXISTING

export const acronymMapToIANA = {
  HST: 'Pacific/Honolulu',
  AKST: 'America/Anchorage',
  PST: 'America/Los_Angeles',
  MST: 'America/Denver',
  CST: 'America/Chicago',
  EST: 'America/New_York',
  AST: 'America/Halifax',
  HDT: 'Pacific/Honolulu',
  AKDT: 'America/Anchorage',
  PDT: 'America/Los_Angeles',
  MDT: 'America/Denver',
  CDT: 'America/Chicago',
  EDT: 'America/New_York',
  ADT: 'America/Halifax',
  IDLW: 'Etc/GMT+12',
  'UTC-11': 'Etc/GMT+11',
  NT: 'America/St_Johns',
  'GMT-3': 'America/Godthab',
  AMT: 'America/Manaus',
  BRT: 'America/Sao_Paulo',
  'UTC+0': 'Etc/UTC',
  CET: 'Europe/Paris',
  EET: 'Europe/Athens',
  FET: 'Europe/Kaliningrad',
  GT: 'Asia/Dubai',
  PKT: 'Asia/Karachi',
  BT: 'Asia/Dhaka',
  ICT: 'Asia/Bangkok',
  CHT: 'Asia/Shanghai',
  JT: 'Asia/Tokyo',
  AET: 'Australia/Sydney',
  VUT: 'Pacific/Efate',
  NZDT: 'Pacific/Auckland'
}